import { IOrderItem, OrderType } from "@/models";
import { useEffect, useState } from "react";
import { toast } from "./ui/use-toast";
import EthCrypto from "eth-crypto";
import { useOrdersWrite } from "@/hooks";
import { getMerchantUpi } from "@/helper/localstorage";
import { ActiveOrderItem } from "./active-orders";
import { Button } from "./ui/button/button";
import { OrderDrawer } from "./OrderDrawer";
import { useOrders } from "@/contexts";
import { ButtonSize } from "./ui/button/button.type";
import { Link } from "react-router-dom";
import { isOrderExpired } from "@/utils/orders";
import { trackAmplitudeEvent } from "@/utils/amplitude";

type AssignedOrdersType = {
  newOrders: any;
  allOrders: any;
  isLoading: boolean;
};

export const AssignedOrders: React.FC<AssignedOrdersType> = ({
  newOrders,
  allOrders,
  isLoading,
}) => {
  const [order, setOrder] = useState<IOrderItem | null>(null);
  const [openedOrderId, setOpenedOrderId] = useState<string | null>(null);
  const { acceptOrder } = useOrdersWrite();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [encUpiId, setEncUpiId] = useState<string | null>(null);
  const [isAccepting, setIsAccepting] = useState(false);
  const { refreshOrders } = useOrders();

  useEffect(() => {
    if (newOrders) {
      setOrder(
        newOrders
          .slice(0, 1)
          .find((order: IOrderItem) =>
            isOrderExpired(parseInt(order.placedTimestamp)),
          ),
      );
    }
  }, [newOrders]);

  useEffect(() => {
    (async () => {
      const upi = await getMerchantUpi();
      if (upi) {
        setEncUpiId(upi);
      }
    })();
  }, []);

  const handleAcceptOrder = async () => {
    if (!order) return null;
    setIsAccepting(true);
    const upiId = order.orderType === OrderType.BUY ? encUpiId : "";
    const _encUpiId =
      order.orderType === OrderType.BUY
        ? await EthCrypto.encryptWithPublicKey(order.pubkey, upiId as string)
        : "";
    console.log(
      order.id,
      JSON.stringify(_encUpiId),
      "order.id, JSON.stringify(_encUpiId)",
    );
    const result = await acceptOrder(order.id, JSON.stringify(_encUpiId));
    if (result?.afterWait?.status === "success") {
      trackAmplitudeEvent("ASSIGNED_ORDER_ACCEPTED");
      setOpenedOrderId(order.id);
      setDrawerOpen(true);
      toast({
        title: "Order Accepted",
        description: `Order ${order.id} status changed from PLACED to ACCEPTED.`,
      });
    } else {
      trackAmplitudeEvent("ASSIGNED_ORDER_ACCEPT_FAILED");
      toast({
        title: "Order wasn't Accepted",
        description: result.message,
        variant: "destructive",
      });
    }
    setIsAccepting(false);
    refreshOrders();
  };

  return (
    <>
      {order && (
        <div className="mx-[24px] mt-2 rounded border-[1px] border-stroke-grey bg-bg-grey p-3">
          <div>
            <div className="flex justify-between">
              <h1 className="text-md font-bold leading-5 tracking-wider text-text-light">
                Latest Assigned Order
              </h1>
              <Link to={"/new-orders"}>
                <h1 className="text-md text-[14px] font-bold leading-5 tracking-wider text-primary text-text-light underline">
                  View All
                </h1>
              </Link>
            </div>
            <div className="items-center">
              <div className="pointer-events-none my-2">
                {order && <ActiveOrderItem {...order} />}
              </div>
              <Button
                label="Accept Order"
                onClick={handleAcceptOrder}
                loading={isAccepting}
                widthFull
                size={ButtonSize.small}
              />
            </div>
          </div>
        </div>
      )}

      {openedOrderId && drawerOpen && (
        <OrderDrawer
          order={allOrders?.find((_: any) => _.id == openedOrderId)}
          autoOpen={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
          }}
          isLoading={isLoading}
        />
      )}
    </>
  );
};
